import axios from 'axios';
import generalCatchError from './generalCatchError';
import { getItem, STORAGE_KEYS } from '../storage';
import config from '../../config';

function getAuth() {
  const user = getItem(STORAGE_KEYS.USER);
  return {
    apiKey: user?.tokenId,
    userEmail: user?.profileObj?.email,
  };
}

class HttpService {
  constructor(baseUrl = '', generalCatch = generalCatchError) {
    this.axiosInstance = axios.create({
      baseURL: baseUrl,
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    });
    this.generalCatch = generalCatch;
  }

  async get(url, options = {}) {
    const { silent, ...axiosOptions } = options;
    try {
      const { apiKey, userEmail } = getAuth();

      const response = await this.axiosInstance.get(url, {
        ...axiosOptions,
        headers: {
          Authorization: `Bearer ${apiKey}`,
          ...axiosOptions.headers,
        },
        params: {
          userEmail,
          ...axiosOptions.params,
        },
      });
      return response.data;
    } catch (error) {
      if (silent) throw error;
      this.generalCatch(error);
    }
  }

  async post(url, data, options = {}) {
    const { silent, ...axiosOptions } = options;
    try {
      const { apiKey, userEmail } = getAuth();

      const response = await this.axiosInstance.post(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...axiosOptions,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...axiosOptions.headers,
          },
          params: {
            userEmail,
            ...axiosOptions.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (silent) throw error;
      this.generalCatch(error);
    }
  }

  async put(url, data, options = {}) {
    const { silent, ...axiosOptions } = options;
    try {
      const { apiKey, userEmail } = getAuth();

      const response = await this.axiosInstance.put(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...axiosOptions,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...axiosOptions.headers,
          },
          params: {
            userEmail,
            ...axiosOptions.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (silent) throw error;
      this.generalCatch(error);
    }
  }

  async patch(url, data, options = {}) {
    const { silent, ...axiosOptions } = options;
    try {
      const { apiKey, userEmail } = getAuth();

      const response = await this.axiosInstance.patch(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...axiosOptions,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...axiosOptions.headers,
          },
          params: {
            userEmail,
            ...axiosOptions.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (silent) throw error;
      this.generalCatch(error);
    }
  }

  async delete(url, options = {}) {
    const { silent, ...axiosOptions } = options;
    try {
      const { apiKey, userEmail } = getAuth();

      const response = await this.axiosInstance.delete(url, {
        ...axiosOptions,
        headers: {
          Authorization: `Bearer ${apiKey}`,
          ...axiosOptions.headers,
        },
        params: {
          userEmail,
          ...axiosOptions.params,
        },
        ...(axiosOptions.data !== undefined
          ? { data: { userEmail, ...axiosOptions.data } }
          : {}),
      });
      return response.data;
    } catch (error) {
      if (silent) throw error;
      this.generalCatch(error);
    }
  }
}

export const httpServiceInstanceNode = new HttpService(config.REACT_APP_NODE_API);
export default HttpService;
